import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { CreateSystemModuleLicenseDto, SystemModuleLicenseDto } from 'types';

export const createServerLicense = async (
  data: CreateSystemModuleLicenseDto
): Promise<SystemModuleLicenseDto> => {
  const response = await axios.post('/api/system-modules/create', data);
  return response.data as SystemModuleLicenseDto;
};

type UseCreateServerLicenseOptions = {
  config?: MutationConfig<typeof createServerLicense>;
};

export const useCreateServerLicense = ({
  config,
}: UseCreateServerLicenseOptions) => {
  return useMutation({
    onError: (_, __, context: any) => {
      if (context?.previousServerLicenses) {
        queryClient.setQueryData(
          ['serverLicenses'],
          context.previousServerLicenses
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['serverLicenses']);
    },
    ...config,
    mutationFn: createServerLicense,
  });
};
